// Source: public team section of mitrakaryalawoffice.com (names, roles, photos, WhatsApp numbers)
const RAW = [
  ["Erlita Aulianisa", "Senior Executive", "erlita-aulanisa", "6281384259546"],
  ["Mia Sri Rahayu", "Senior Executive", "mia-sri-rahayu", "6285213509610"],
  ["Fariha Al Munawaroh", "Senior Executive", "fariha-al-munawaroh", "6285213509634"],
  ["Devani", "Senior Partner", "devani", "6285210160805"],
  ["Alfiah", "Senior Partner", "alfiah", "6282261861413"],
  ["Alya Nurkhaliza", "Senior Partner", "alya-nurkhaliza", "6282121913136"],
  ["Nurfiska Sismiati", "Senior Partner", "nurfiska-sismiati", "6285286197037"],
  ["Dinda", "Senior Partner", "dinda-a-caesar", "6281214240695"],
  ["Siska Ervianti", "Senior Partner", "siska-ervianti", "6282261861486"],
  ["Novita Sari", "Senior Partner", "novita-sari", "628138774564"],
  ["Dina Novia Putri", "Senior Partner", "dina-novia-putri", "6285284193050"],
  ["Shalsa Agnestia", "Senior Partner", "salsa-agnestia", "6285284193057"],
  ["Nuhaa Nurhasanah", "Senior Partner", "nuha-nurhasanah", "6285286197034"],
  ["Yulia", "Senior Partner", "yulia", "6281214240930"],
  ["Azzahra Tusadiyah", "Senior Partner", "azzahra-tussadiyah", "6282121913120"],
  ["Tazkiya Mega", "Senior Partner", "tazkiya-mega", "6282261809596"],
  ["Fitria Handrayani", "Senior Partner", "fitria-handayani", "6281214240930"],
  ["Ambar Savika", "Senior Partner", "ambar-savika", "6282317848310"],
  ["Ahmad Juanda", "Senior Client Service", "ahmad-juanda", "6285210160789"],
  ["Sri Anggranita", "Senior Client Service", "sri-anggranita", "6285212500127"],
  ["Akbar Fadilah", "Senior Client Service", "akbar-fadilah", "6282317848308"],
  ["Rizky Maulana", "Senior Client Service", "rizky-maulana", "6281994331642"],
  ["Anisa Fitri", "Senior Client Service", "anisa-fitri", "6282343424463"],
  ["Kharel", "Senior Client Service", "kharel", "6282317848306"],
];

export const CONSULTANTS = RAW.map(([name, role, slug, wa]) => ({
  name,
  role,
  slug,
  wa,
  photo: `/images/team/${slug}.webp`,
}));

export const getConsultant = (slug) => CONSULTANTS.find((c) => c.slug === slug);

export const consultantWa = (c, topic = "kondisi kewajiban finansial saya") =>
  `https://wa.me/${c.wa}?text=${encodeURIComponent(`Halo ${c.name}, saya dapat info dari website Mika Solution dan ingin berkonsultasi mengenai ${topic}.`)}`;

export const formatPhone = (wa) => `+${wa.slice(0, 2)} ${wa.slice(2, 5)}-${wa.slice(5, 9)}-${wa.slice(9)}`;
